package com.isaias.fyattravel.web.i18n
 
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window
 
object WebLocaleStore {
    private const val STORAGE_KEY = "fyat.web.locale"
    private val _locale = mutableStateOf(loadLocale())
    val locale: State<WebLocale> get() = _locale
 
    fun setLocale(newLocale: WebLocale) {
        if (_locale.value == newLocale) return
        _locale.value = newLocale
        persistLocale(newLocale)
        applyDocumentLocale(newLocale)
    }
 
    fun isRtl(locale: WebLocale = _locale.value): Boolean = locale.isRtl
 
    fun applyDocumentLocale(locale: WebLocale = _locale.value) {
        val root = document.documentElement ?: return
        root.setAttribute("lang", locale.code)
        root.setAttribute("dir", if (locale.isRtl) "rtl" else "ltr")
    }
 
    private fun loadLocale(): WebLocale {
        val stored = runCatching { localStorage.getItem(STORAGE_KEY) }.getOrNull()
        val storedLocale = WebLocale.values().firstOrNull { it.code == stored }
        if (storedLocale != null) return storedLocale
 
        val browserLang = runCatching { window.navigator.language }.getOrNull()?.lowercase().orEmpty()
        return WebLocale.values().firstOrNull { browserLang.startsWith(it.code) } ?: WebLocale.EN
    }
 
    private fun persistLocale(locale: WebLocale) {
        runCatching { localStorage.setItem(STORAGE_KEY, locale.code) }
    }
}